var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.688 3.74741C33.2962 2.27468 32.1374 1.11286 30.663 0.714683C27.997 0.000137589 17.3007 0.000137329 17.3007 0.000137329C17.3007 0.000137329 6.60978 0.000137589 3.93842 0.714683C2.46944 1.10741 1.31058 2.26923 0.91341 3.74741C0.200684 6.42014 0.200684 12.0001 0.200684 12.0001C0.200684 12.0001 0.200684 17.5801 0.91341 20.2529C1.30514 21.7256 2.464 22.8874 3.93842 23.2856C6.60978 24.0001 17.3007 24.0001 17.3007 24.0001C17.3007 24.0001 27.997 24.0001 30.663 23.2856C32.1319 22.8929 33.2908 21.731 33.688 20.2529C34.4007 17.5801 34.4007 12.0001 34.4007 12.0001C34.4007 12.0001 34.4007 6.42014 33.688 3.74741Z",
    fill: "#FF3000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8839 17.1438L22.7686 12.0001L13.8839 6.8565V17.1438Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.966564683dc0e04cb834fc883a9d678f.svg";
export { ForwardRef as ReactComponent };